/*
 * Wellness Questionnaire - UI layer.
 * Scoring lives in wellness-quiz-score.js so the browser and the Node
 * regression test (scripts/validate_wellness_quiz.mjs) share one implementation.
 */
(function () {
  'use strict';

  document.querySelectorAll('.wq[data-map-url]').forEach(init);

  function init(root) {
    var els = {
      intro: root.querySelector('[data-wq-intro]'),
      start: root.querySelector('[data-wq-start]'),
      stage: root.querySelector('[data-wq-stage]'),
      form: root.querySelector('[data-wq-form]'),
      qTitle: root.querySelector('[data-wq-question-title]'),
      qDesc: root.querySelector('[data-wq-question-desc]'),
      answers: root.querySelector('[data-wq-answers]'),
      back: root.querySelector('[data-wq-back]'),
      next: root.querySelector('[data-wq-next]'),
      hint: root.querySelector('[data-wq-hint]'),
      progressFill: root.querySelector('[data-wq-progress-fill]'),
      progressText: root.querySelector('[data-wq-progress-text]'),
      results: root.querySelector('[data-wq-results]'),
      headline: root.querySelector('[data-wq-headline]'),
      singles: root.querySelector('[data-wq-singles]'),
      restart: root.querySelector('[data-wq-restart]'),
      capture: root.querySelector('[data-wq-capture]'),
      email: root.querySelector('[data-wq-email]'),
      emailSubmit: root.querySelector('[data-wq-email-submit]'),
      emailMsg: root.querySelector('[data-wq-email-msg]')
    };

    var moneyFormat = root.dataset.moneyFormat || '';
    var catalog = {};
    var map = null;
    var state = { index: 0, selections: {} };

    try {
      var node = root.querySelector('[data-wq-catalog]');
      catalog = JSON.parse(node.textContent);
    } catch (e) {
      catalog = {};
    }

    els.start.addEventListener('click', function () {
      loadMap().then(function () {
        els.intro.hidden = true;
        els.stage.hidden = false;
        state.index = 0;
        state.selections = {};
        trackedSteps = {};
        track('quiz_start', 'start', { quiz_length: map.questions.length });
        renderQuestion();
      });
    });

    function loadMap() {
      if (map) return Promise.resolve(map);
      return fetch(root.dataset.mapUrl, { credentials: 'omit' })
        .then(function (r) { return r.json(); })
        .then(function (json) { map = json; return map; })
        .catch(function () {
          // If the map itself can't load there is nothing to ask. Send the
          // shopper somewhere useful rather than showing a broken widget.
          els.intro.hidden = true;
          els.stage.hidden = true;
          els.results.hidden = false;
          els.headline.innerHTML = '';
          renderFallbackOnly();
          throw new Error('map unavailable');
        });
    }

    /*
     * GA4 funnel tracking, sent straight to gtag (G-FYSNELN2BX in theme.liquid).
     * Deliberately NOT routed through GTM: container GTM-PTMWC768 on this site
     * belongs to a third party and we have no access to it.
     *
     * The step name goes in `event_label` because that is already registered as
     * a custom dimension on the property, so the funnel is reportable in GA4
     * immediately with no admin setup.
     *
     * No answer content is ever sent. These are health responses, and Google's
     * policy prohibits sending sensitive health data. Step index only.
     */
    var trackedSteps = {};
    function track(eventName, label, extra) {
      if (typeof window.gtag !== 'function') return;
      var payload = { event_category: 'wellness_quiz', event_label: label };
      if (extra) {
        Object.keys(extra).forEach(function (k) { payload[k] = extra[k]; });
      }
      try { window.gtag('event', eventName, payload); } catch (e) {}
    }

    function stepLabel(index, q) {
      return ('0' + (index + 1)).slice(-2) + '_' + q.id;
    }

    function money(cents) {
      return window.WellnessQuizScore.formatMoney(cents, moneyFormat);
    }

    // Five products (CTF, Burgstiner, Lyme, M-Support, the special offer) have
    // multiple variants at different prices. Show the default purchasable
    // variant and mark it as a starting price rather than implying it's the only one.
    function priceLabel(product) {
      return (product.priceVaries ? 'From ' : '') + money(product.price);
    }

    function currentQuestion() {
      return map.questions[state.index];
    }

    function renderQuestion() {
      var q = currentQuestion();
      var selected = state.selections[q.id] || [];

      els.qTitle.textContent = q.name;
      if (q.description) {
        els.qDesc.textContent = q.description;
        els.qDesc.hidden = false;
      } else {
        els.qDesc.hidden = true;
      }

      els.answers.innerHTML = '';
      q.answers.forEach(function (a) {
        var id = 'wq-' + q.id + '-' + a.id;
        var label = document.createElement('label');
        label.className = 'wq__answer';
        label.setAttribute('for', id);

        var input = document.createElement('input');
        input.type = q.multi ? 'checkbox' : 'radio';
        input.name = 'wq-' + q.id;
        input.id = id;
        input.value = a.id;
        input.checked = selected.indexOf(a.id) !== -1;
        input.addEventListener('change', function () {
          onSelect(q, a.id, input.checked);
        });

        var text = document.createElement('span');
        text.className = 'wq__answer-text';
        text.textContent = a.label;

        label.appendChild(input);
        label.appendChild(text);
        els.answers.appendChild(label);
      });

      els.back.hidden = state.index === 0;
      els.next.textContent = state.index === map.questions.length - 1 ? 'See my results' : 'Next';
      els.hint.hidden = true;

      var pct = Math.round((state.index / map.questions.length) * 100);
      els.progressFill.style.width = pct + '%';
      els.progressText.textContent = 'Question ' + (state.index + 1) + ' of ' + map.questions.length;

      var label = stepLabel(state.index, q);
      if (!trackedSteps[label]) {
        trackedSteps[label] = true;
        track('quiz_step', label, { step_index: state.index + 1 });
      }

      els.qTitle.focus && els.qTitle.focus();
    }

    function onSelect(q, answerId, checked) {
      var current = state.selections[q.id] || [];
      if (q.multi) {
        state.selections[q.id] = checked
          ? current.concat([answerId])
          : current.filter(function (x) { return x !== answerId; });
      } else {
        state.selections[q.id] = [answerId];
      }
      els.hint.hidden = true;
    }

    els.form.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = currentQuestion();
      var picked = state.selections[q.id] || [];
      if (!picked.length) {
        els.hint.hidden = false;
        return;
      }
      if (state.index < map.questions.length - 1) {
        state.index += 1;
        renderQuestion();
      } else {
        showResults();
      }
    });

    els.back.addEventListener('click', function () {
      if (state.index > 0) {
        track('quiz_back', stepLabel(state.index, currentQuestion()), { step_index: state.index + 1 });
        state.index -= 1;
        renderQuestion();
      }
    });

    // Delegated: result cards are rebuilt via innerHTML on every run, so bind once
    // on the container rather than per card. This is the link between the quiz and
    // revenue - which recommendations actually send people to a product page.
    els.results.addEventListener('click', function (e) {
      var link = e.target.closest ? e.target.closest('a[href^="/products/"]') : null;
      if (!link) return;
      var isHeadline = !!(link.closest && link.closest('.wq__headline'));
      var handle = link.getAttribute('href').replace('/products/', '');
      track('quiz_result_click', handle, {
        result_position: isHeadline ? 'headline_bundle' : 'single'
      });
      tagCart(handle, isHeadline);
      tagKlaviyo(handle, isHeadline);
    });

    /*
     * Revenue attribution. Cart attributes ride the cart through checkout and
     * land on the Shopify order as note_attributes, so an order can be tied back
     * to the quiz via the Admin API - independent of GA4, and surviving ad
     * blockers and cookie refusal. This is the only hard link between the quiz
     * and revenue; the GA4 events above can show intent but never a sale.
     *
     * Deliberately NOT utm_* params on the product link: internal UTMs start a
     * new GA4 session and overwrite the visitor's real acquisition source with
     * "internal", which would corrupt all channel reporting to measure one page.
     *
     * The `_` prefix keeps these hidden from the customer's cart and order
     * confirmation while still saving them to the order. That matters here: the
     * recommendation handle can imply a health condition, and it belongs in the
     * merchant's own order record, not on a page shown back to the shopper.
     *
     * keepalive:true because the click navigates away immediately - without it
     * the browser cancels the request in flight and the attribution is lost.
     */
    function tagCart(handle, isHeadline) {
      if (typeof fetch !== 'function') return;
      try {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          keepalive: true,
          body: JSON.stringify({
            attributes: {
              _quiz_source: 'wellness-questionnaire',
              _quiz_recommendation: handle,
              _quiz_type: isHeadline ? 'bundle' : 'single',
              _quiz_clicked_at: new Date().toISOString().slice(0, 10)
            }
          })
        }).catch(function () {});
      } catch (e) {}
    }

    /*
     * First-party segmentation. Klaviyo's onsite JS (company SRQcmS) is already
     * loaded sitewide and identifies anyone arriving from a Klaviyo email via the
     * _kx parameter, so this attaches the clicked recommendation to a profile we
     * ALREADY know. It never creates one: an un-identified visitor produces
     * nothing, which is deliberate.
     *
     * Fired on result CLICK, not on quiz completion. A recommendation handle can
     * imply a health condition (same reason tagCart uses the `_` prefix above),
     * so it is recorded only once the shopper takes an affirmative commercial
     * action on that recommendation. Browsing the quiz and leaving records nothing.
     *
     * Sends the recommendation handle only - never the raw symptom answers, for
     * the same reason the GA4 tracking above sends step indexes only.
     */
    function tagKlaviyo(handle, isHeadline) {
      var learnq = window._learnq;
      if (!learnq || typeof learnq.push !== 'function') return;
      try {
        learnq.push(['track', 'Completed Quiz', {
          recommendation: handle,
          recommendation_type: isHeadline ? 'bundle' : 'single'
        }]);
      } catch (e) {}
    }

    els.restart.addEventListener('click', function () {
      els.results.hidden = true;
      els.intro.hidden = false;
      state.index = 0;
      state.selections = {};
    });

    function productCard(product, note) {
      if (!product) return '';
      var img = product.image
        ? '<img class="wq__card-img" src="' + product.image + '" alt="" loading="lazy" width="200" height="200">'
        : '';
      return (
        '<a class="wq__card" href="' + product.url + '">' +
        img +
        '<span class="wq__card-title">' + escapeHtml(product.title) + '</span>' +
        '<span class="wq__card-price">' + priceLabel(product) + '</span>' +
        (note ? '<span class="wq__card-note">' + escapeHtml(note) + '</span>' : '') +
        '</a>'
      );
    }

    function renderFallbackOnly() {
      // Used only when the map fails to load - never leave the shopper empty-handed.
      var picks = ['burgstiner-wellness-protocol', 'thymic-formula']
        .map(function (h) { return catalog[h]; })
        .filter(Boolean);
      els.singles.innerHTML =
        '<p class="wq__lede">Here are two good places to start.</p>' +
        '<div class="wq__grid">' + picks.map(function (p) { return productCard(p); }).join('') + '</div>';
    }

    function showResults() {
      var result = window.WellnessQuizScore.score(map, state.selections, catalog);

      els.stage.hidden = true;
      els.results.hidden = false;

      track('quiz_complete', result.headline ? result.headline.handle : 'no_bundle', {
        recommended_count: result.singles.length,
        used_fallback: result.usedFallback ? 1 : 0
      });

      // Sticks to the GA4 user for the retention window, so `purchase` events can
      // be segmented by quiz participation in a standard GA4 report. A flag only -
      // no condition, no bundle handle, nothing that infers health status.
      if (typeof window.gtag === 'function') {
        try {
          window.gtag('set', 'user_properties', { quiz_participant: 'yes' });
        } catch (e) {}
      }

      if (result.headline) {
        var h = result.headline;
        var savingsLine = h.showSavings
          ? '<p class="wq__headline-savings">Bought separately these come to ' +
            money(h.componentTotal) + ' — <strong>you save ' + money(h.savings) +
            ' (' + h.savingsPct + '%)</strong>.</p>'
          : '';
        // Only claim coverage when it actually supports the pitch. A bundle can
        // headline on a direct match alone, and "covers 1 of the 6 formulas we
        // suggested" next to a $118 kit argues against itself.
        var coverageLine = h.coverage > 1
          ? '<p class="wq__headline-coverage">Covers ' + h.coverage + ' of the ' +
            result.singles.length + ' formulas we suggested for you.</p>'
          : '';
        els.headline.innerHTML =
          '<div class="wq__headline">' +
          '<p class="wq__headline-kicker">Your best match</p>' +
          '<h3 class="wq__headline-title">' + escapeHtml(h.product.title) + '</h3>' +
          '<p class="wq__headline-price">' + priceLabel(h.product) + '</p>' +
          coverageLine +
          savingsLine +
          '<a class="wq__btn wq__btn--primary" href="' + h.product.url + '">View this protocol</a>' +
          '</div>';
      } else {
        els.headline.innerHTML = '';
      }

      var intro = result.usedFallback
        ? '<p class="wq__lede">Nothing in your answers pointed to a specific concern — these are the formulas most people start with.</p>'
        : (result.headline
            ? '<p class="wq__lede">Or choose individual formulas:</p>'
            : '<p class="wq__lede">Based on your answers, these formulas suit you best:</p>');

      els.singles.innerHTML =
        intro +
        '<div class="wq__grid">' +
        result.singles.map(function (s) {
          return productCard(s.product, s.inHeadlineBundle ? 'Included in your kit' : '');
        }).join('') +
        '</div>';

      if (els.capture) setupCapture(result);
    }

    function setupCapture(result) {
      if (root.dataset.emailCapture !== 'true') return;
      els.emailSubmit.addEventListener('click', function () {
        var email = (els.email.value || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          showMsg('Please enter a valid email address.');
          return;
        }
        var listId = root.dataset.klaviyoList;
        var publicKey = root.dataset.klaviyoKey;
        if (!listId || !publicKey) {
          showMsg('Email delivery is not configured yet.');
          return;
        }
        els.emailSubmit.disabled = true;
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(publicKey), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: email,
                      properties: {
                        quiz_results: result.singles.map(function (s) { return s.product.title; }),
                        quiz_best_match: result.headline ? result.headline.product.title : null
                      }
                    }
                  }
                }
              },
              relationships: { list: { data: { type: 'list', id: listId } } }
            }
          })
        })
          .then(function () { showMsg('Sent — check your inbox.'); })
          .catch(function () { showMsg('Something went wrong. Please try again.'); })
          .finally(function () { els.emailSubmit.disabled = false; });
      });

      function showMsg(text) {
        els.emailMsg.textContent = text;
        els.emailMsg.hidden = false;
      }
    }

    function escapeHtml(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
  }
})();
